import React from 'react';

import { FaBan, FaSearch, FaExclamationTriangle, FaExclamationCircle, FaTimesCircle } from 'react-icons/fa';

import styles from './AppError.module.css';

const ICONS: Record<string, React.ComponentType<{ size?: number | string }>> = {
  '403': FaBan,
  '404': FaSearch,
  '422': FaExclamationTriangle,
  '429': FaExclamationCircle,
  '500': FaTimesCircle,
};

interface Props {
  statusCode: number | undefined;
}

const AppErrorIcon = ({ statusCode }: Props) => {
  const IconComponent = ICONS[String(statusCode)] || ICONS['500'];
  return (
    <div className={ styles.errorIcon }>
      <IconComponent size={ 64 }/>
    </div>
  );
};

export default AppErrorIcon;
